module.exports = __webpack_public_path__ + "assets/img/b6926095b6fe8c9facd86e789af946dd.png";